import { Controller } from "@hotwired/stimulus"
import Swal from 'sweetalert2'

// Stimulus controller para gerenciar edição inline da matriz de client overrides
export default class extends Controller {
  static targets = ["input"]

  connect() {
    console.log("Client matrix editor controller connected")
    this.setupEditableFields()
  }

  setupEditableFields() {
    // Salvar valores originais para reverter em caso de erro
    this.element.querySelectorAll('input[type="number"]').forEach(input => {
      input.dataset.originalValue = input.value
    })
  }

  // Validar input antes de enviar
  validateInput(field) {
    const value = parseFloat(field.value)
    const attribute = field.dataset.attribute
    
    // Validar se é um número
    if (isNaN(value)) {
      this.showError(['O valor deve ser um número'])
      return false
    }

    // Validações de ordem para campos de bucket
    if (attribute === 'min_total') {
      const maxField = field.closest('div').querySelector('[data-attribute="max_total"]')
      if (maxField && parseFloat(maxField.value) <= value) {
        this.showError(['O valor mínimo deve ser menor que o valor máximo'])
        return false
      }
    }

    if (attribute === 'max_total') {
      const minField = field.closest('div').querySelector('[data-attribute="min_total"]')
      if (minField && parseFloat(minField.value) >= value) {
        this.showError(['O valor máximo deve ser maior que o valor mínimo'])
        return false
      }
    }

    // Validações específicas para score
    if (attribute === 'score') {
      if (!Number.isInteger(value)) {
        this.showError(['A pontuação deve ser um número inteiro'])
        return false
      }
    }

    return true
  }

  // Action chamada quando um input de ClientBandOverride muda
  updateClientBandOverride(event) {
    const field = event.target
    
    // Validar antes de enviar
    if (!this.validateInput(field)) {
      field.value = field.dataset.originalValue
      return
    }

    const id = field.dataset.clientBandOverrideId
    const attribute = field.dataset.attribute
    const value = field.value

    Rails.ajax({
      url: `/client_band_overrides/${id}/update_inline`,
      type: 'PATCH',
      data: `client_band_override[${attribute}]=${value}`,
      success: (response) => {
        field.dataset.originalValue = value
        this.showSuccess('Override de banda atualizado com sucesso')
      },
      error: (response) => {
        const errors = response.errors || ['Erro ao atualizar']
        this.showError(errors)
        field.value = field.dataset.originalValue
      }
    })
  }

  // Action chamada quando um input de ClientBucketOverride muda
  updateClientBucketOverride(event) {
    const field = event.target
    
    // Validar antes de enviar
    if (!this.validateInput(field)) {
      field.value = field.dataset.originalValue
      return
    }

    const id = field.dataset.clientBucketOverrideId
    const attribute = field.dataset.attribute
    const value = field.value

    Rails.ajax({
      url: `/client_bucket_overrides/${id}/update_inline`,
      type: 'PATCH',
      data: `client_bucket_override[${attribute}]=${value}`,
      success: (response) => {
        field.dataset.originalValue = value
        this.showSuccess('Override de bucket atualizado com sucesso')
      },
      error: (response) => {
        const errors = response.errors || ['Erro ao atualizar']
        this.showError(errors)
        field.value = field.dataset.originalValue
      }
    })
  }

  showSuccess(message) {
    Swal.fire({
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 1500
    })
  }

  showError(errors) {
    Swal.fire({
      icon: 'error',
      title: 'Erro',
      text: errors.join(', '),
      confirmButtonText: 'OK'
    })
  }
}

